import { pick } from 'lodash'

import { MembershipWithCurrentPlayer } from '../../../../app/containers/Tournaments/types/Membership'
import trans from '../../../trans'
import {
  CURRENT_USER_CLASS_NAME,
  POSITION_DOWN_CLASS_NAME,
  POSITION_SAME_CLASS_NAME,
  POSITION_UP_CLASS_NAME,
} from '../constants'

class ScoreboardBuilder {
  newTable: HTMLTableSectionElement
  previousTable: HTMLTableElement
  noClassifiedUsersLabel: string

  constructor(previousTable: HTMLTableElement) {
    this.previousTable = previousTable
    this.newTable = document.createElement('tbody')
    this.newTable.dataset.tournament = 'tbody'
    this.noClassifiedUsersLabel = trans('no_classified_users_yet')
  }

  getTable() {
    if (this.newTable.childNodes.length === 0) {
      this.appendNoRecordsRow()
    }

    return this.newTable
  }

  addUser(user: MembershipWithCurrentPlayer) {
    this.appendRowToTable(user)
  }

  private appendRowToTable(user: MembershipWithCurrentPlayer) {
    this.newTable.appendChild(this.createRow(user))
  }

  private createRow(user: MembershipWithCurrentPlayer) {
    const tr = document.createElement('tr')
    this.addRowContent(tr, user)
    this.addCurrentUserClassName(tr, user)
    this.addDatasetAttributes(tr, user)
    this.addAnimations(tr, user)

    return tr
  }

  private addRowContent(tr: HTMLTableRowElement, user: MembershipWithCurrentPlayer) {
    Object.values(pick(user, 'position', 'name', 'score', 'rewardAmt')).forEach(
      (value: string | number | null | undefined) => {
        const td = document.createElement('td')
        const titleString = value?.toString() || ''
        td.title = titleString
        td.append(titleString)
        tr.appendChild(td)
      },
    )
  }

  private addCurrentUserClassName(tr: HTMLTableRowElement, user: MembershipWithCurrentPlayer) {
    if (user.isCurrentPlayer) {
      tr.classList.add(CURRENT_USER_CLASS_NAME)
    }
  }

  addDatasetAttributes(tr: HTMLTableRowElement, user: MembershipWithCurrentPlayer) {
    tr.dataset.position = user.position?.toString()
    tr.dataset.score = user.score?.toString()
    tr.dataset.userId = user.id.toString()
    tr.dataset.userName = user.name
  }

  addAnimations(tr: HTMLTableRowElement, user: MembershipWithCurrentPlayer) {
    const userPosition = user.position || 0
    const previousRow = [...this.previousTable.rows].find(({ dataset }) => dataset.userId === user.id.toString())
    const previousPlaceOffsetTop = this.previousTable.rows[userPosition - 1]?.offsetTop

    const { score } = user
    const prevScore = Number(previousRow?.dataset?.score)

    if (previousRow && previousPlaceOffsetTop) {
      const previousPosition = Number(previousRow.dataset.position)
      const distY = Number(previousRow.offsetTop) - previousPlaceOffsetTop
      const htmlPositionDifference = Math.sqrt(distY * distY)

      if (userPosition < previousPosition) {
        tr.style.setProperty('--change', POSITION_UP_CLASS_NAME)
        tr.style.setProperty('--position', `${htmlPositionDifference}px`)
      } else if (userPosition > previousPosition) {
        tr.style.setProperty('--change', POSITION_DOWN_CLASS_NAME)
        tr.style.setProperty('--position', `-${htmlPositionDifference}px`)
      } else if (score !== prevScore) {
        tr.style.setProperty('--change', POSITION_SAME_CLASS_NAME)
      }
    }
  }

  private appendNoRecordsRow() {
    const tr = document.createElement('tr')
    tr.innerHTML = `<tr><th colspan="4"><p class="gray" style="text-align: center;">${this.noClassifiedUsersLabel}</p></th></tr>`
    this.newTable.appendChild(tr)
  }
}

export default ScoreboardBuilder
